'use strict'

angular
  .module('basalteApp')
  .constant('BAS_MESSAGES', {
    EVT_MESSAGES_UPDATED: 'evtBasMessagesUpdated'
  })
